
import ResumenAlumno from "./subComponents/ResumenAlumno";
import Card from "./subComponents/Card";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import Resumen from "./subComponents/Resumen";
import WarningModal from "../../components-modals/WarningModal";
import Total from "./subComponents/Total";
import { formatearFechaASinDiagonales } from "../../tools/ConversionFechas";
import { getSedes, postCursos } from "../api/";
import Cursos from "./Cursos";
import { getCatalogos } from "../api/";

import ResumenAsignados from "./subComponents/ResumenAsignados";

const Admision = ({ urlCursos, state, send, headers, respuesta, setLoading, pathname, IdEmp }) => {

  const [modal, setModal] = useState({
    ok: false,
    show: false,
    msg: ""
  })

  const [cursos, setCursos] = useState([]);

  const [sede, setSede] = useState("");
  const [idCurso, setIdCurso] = useState("");
  const [verCursos, setVerCursos] = useState(false)
  const [nombreVisible, setNombreVisible] = useState(true)
  const [sedeNombre, setSedeNombre] = useState("")
  const [contador, setContador] = useState(0)
  const [modalidad, setModalidad] = useState("")

  const [catalogos, setCatalogos] = useState()

  const [copySeleccionadosSource, setcopySeleccionadosSource] = useState([...state.context.seleccionados])

  const sedesIds = (id) => {
    const opcion = {
      '51': () => "SJ",
      '52': () => "PT",
      '54': () => "AB",
      '55': () => "Z6",
      '56': () => "SC",
      '57': () => "VN",
      '58': () => "NJ",
      '59': () => "VD",
    }
    return opcion[id]()
  }

  const handleOpen = (idCurso) => {
    setIdCurso(idCurso)
    setVerCursos(true)

  }

  const guardarCursosSeleccionados = () => {
    let cursos = []
    const datosString = JSON.stringify(state.context.seleccionados)
    let datos = JSON.parse(datosString)  // copia  de arrays

    datos.forEach((element, index) => {
      element.Cupones = element.Cupones.filter(cupon => cupon.Aplicar || cupon.Aplicado)
    })
    datos.forEach(element => { // yyyymmdd
      element.De = formatearFechaASinDiagonales(element.De)
      element.A = formatearFechaASinDiagonales(element.A)
      if (element.Header) {
        const filtro = datos.filter(el => el.Key === element.Key)
        const completo = element.Header
        completo.Cargos = filtro
        cursos.push(completo)
      }
    })
    const cursosFiltrados = cursos;
    const dataEnviar = {
      "Carnet": state.context.carnet,
      "IdSolicitud": parseInt(state.context.solicitud),
      "Cursos": { "Cursos": cursosFiltrados },
      "CursosAntes": state.context.opcion === 0 ? { "Cursos": state.context?.CursosAntes[0]?.Cursos } : { "Cursos": state.context?.CursosAntes },
      "HostName": "DEV07",
      "IpHost": "131.107.1.235",
      "IdEmp": IdEmp,// puede ser extraído del usuario público
      "OS": "Windows"
    }
    postCursos(urlCursos, headers, dataEnviar, setModal, send, setLoading, state.context.datosUsuario.Modalidad, state.context.opcion)
  }

  const handleDelete = (index) => {
    const cursosCopia = [...cursos]
    const totosSeleccionados = state.context.seleccionados
    const seleccionado = state.context.seleccionados[index]
    const indexCurso = seleccionado?.IndexCurso
    const indexHorario = seleccionado?.IndexHorario
    const key = state.context.seleccionados[index].Key

    const selectedSameOrder = state.context.seleccionados.filter(element => element.Key === key)
    const seleccionadosLength = selectedSameOrder.length
    const inicio = state.context.seleccionados[index].Orden
    
    const idcargo = selectedSameOrder[0]['IdCargo']
    totosSeleccionados.forEach((e, indexf) => {
      
      if (e.IdCargo === idcargo) {
        try {
          let encontrado = cursosCopia[indexCurso].Horarios[indexHorario].Cargos.find((e) => e.IdCargo + e.Orden === seleccionado.IdCargo + seleccionado.Orden)
          encontrado.Seleccionado = false
          encontrado.Pagar = 0
        } catch (error) {
          console.log(error)
        }
        totosSeleccionados[index].Seleccionado = false
        totosSeleccionados[index].Pagar = 0
      }
    })

    for (let ix = inicio - 1; ix < seleccionadosLength; ix++) {
      try {
        cursosCopia[indexCurso].Horarios[indexHorario].Cargos[ix].Seleccionado = false
      } catch (error) {
        console.log(error)
      }
    }
    const aeliminar = state.context.seleccionados[index]
    const filtrado = totosSeleccionados.filter(e => (e.IdCargo + e.De) !== (aeliminar.IdCargo + aeliminar.De))
    send("QUITAR", { quitar: filtrado });
  }

  const handleSede = (value, nombreSede) => {
    setSede(() => value)
    send("GUARDAR_SEDE", { sede: value })
  }

  const getCatalogosresponse = async () => {
    // const catalogos = await getCatalogos(urlCursos, send, headers, state.context?.datosUsuario?.Modalidad);
    const catalogos = await getCatalogos(urlCursos, send, headers, state.context?.datosUsuario?.Modalidad, state.context?.idCursoD?.IdCurso);
    setCatalogos(catalogos.msg)
    send("CARGAR_CATALOGOS", { catalogos: catalogos.msg });
  }
  const handleAplicaCupon = (props) => {
    const {IdCargo, Codigo, IdCupon, Orden, CodigoIngresado, Nombre} = props
    const codigoIngresadoLocal = CodigoIngresado[`${Nombre}`]

    if(Codigo == codigoIngresadoLocal){
     const copia = state.context.seleccionados
     copia.filter(item => item.Orden == Orden && item.IdCargo == IdCargo)[0].Cupones.filter(element => element.IdCupon == IdCupon)[0].Aplicar = true
     let copiaSeleccionado = copia.filter(item => item.Orden == Orden && item.IdCargo == IdCargo)
    copiaSeleccionado[0].Descuento = copiaSeleccionado[0].Cupones.filter(element => element.Aplicar).reduce((prev, next) => prev + next.ValorCupon, 0)
    copiaSeleccionado[0].Valor = copiaSeleccionado[0].precioAnterior - (copiaSeleccionado[0].Cupones.filter(element => element.Aplicar).reduce((prev, next) => prev + next.ValorCupon, 0))
    
    copiaSeleccionado[0].Cupones.filter(element => element.Aplicar).reduce((prev, next) => prev + next.ValorCupon, 0)
    copiaSeleccionado[0].Cupones.forEach(e => {
      
      if(e.IdCupon === IdCupon){
          e.Aplicado = true
      }
    })
     // SI EL CUPON NO SE HA VALIDADO, SE PROCEDE A ELIMINAR EL CUPON DEL ARRAY cUPONES, ANTES QUE SE ENVIE A ASIGNAR_CURSOS
     send("SELECCIONAR", {seleccionado:  copia}) 
    } else {
      setModal({
        show:true,
        msg:"El cupón ingresado no coincide, inténtelo de nuevo"
      })
    }
  }

  useEffect(() => {
    getSedes(urlCursos, send, headers)
    getCatalogosresponse()
    if(state.context.datosUsuario.Modalidad === "1"){
      setModalidad("1")
      setSede("59")
      setNombreVisible(true)
      send("GUARDAR_SEDE", { sede: "59" })
      setSedeNombre("Virtual a distancia")
    }else{
      setModalidad("0")
      send("GUARDAR_SEDE", { sede: "" })
      setSede("")
      setVerCursos(() => false)
      setNombreVisible(false)
    }
    if (state.context.opcion > 1) {
      send("RESET_SELECCIONADOS", { reset: [] });
    }
  }, [])

  const showOptions = () => {
    setModal({
      ok: false,
      show: true,
      msg: "Se perderán los datos seleccionados. ¿Desea volver atrás?",
      showOptions: true
    })
  }

  return (
    <div>

      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6">
          {modal.showOptions ?
            <div className='flex flex-row justify-between'>
              <button
                onClick={() => {
                  pathname === '/campus/centro'
                    ? send("CANCELAR")
                    : state.context.opcion === 0
                      ? send("CANCELAR_2")
                      : send("CANCELAR_2")
                }}
                className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >Atrás</button>
              <button
                onClick={() => setModal({ show: false })}
                className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >Cancelar</button>
            </div>
            :
            <button
              onClick={() => {
                if (modal.reload) {
                  window.location.reload();
                }
                setModal((curr) => ({
                  ...curr,
                  show: false,
                  reload: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >
              Entendido
            </button>
          }
        </div>

      </WarningModal>
      <div className="sm:flex w-full sm:flex-col lg:flex-row ">

        <div className={"xl:p-2 w-[100%] md:w-[100%] xl:w-[80%]"}>
          {!verCursos && state.context.opcion !== 3 &&
            <>
            {modalidad !== "1"?
              <div className={"flex m-auto lg:flex-row flex-col xl:justify-center elementFadeIn"}>
                {state.context.sedes.map(element => (element.IdSede !== "59") && (
                  
                  <>
                    <div className="flex flex-row">
                      <div
                        className={state.context.sede === element['IdSede'] ?
                        "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 bg-azulBrillanteMira hover:shadow-md hover:shadow-white" :
                        "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 hover:bg-azulBrillanteMira hover:shadow-md hover:shadow-white"}
                        onClick={() => handleSede(element['IdSede'], element.Nombre)}
                        onMouseEnter={() => setSedeNombre(element.Nombre)}
                      >
                        <p className="m-auto text-white text-2xl font-bold">{sedesIds(element['IdSede'])}</p>
                      </div>
                      <p className="block lg:hidden m-auto text-white">{element.Nombre}</p>
                    </div>
                  </>
                ))}

                <div className={"flex lg:w-1/2 w-full flex-col"}>
                  <p className="text-secundario m-auto hidden xl:inline p-2">Para continuar, es importante que elija una sede, ya que esta elección le permitirá acceder a los catálogos de cursos disponibles en dicha sede.</p>
                  {nombreVisible ? <p className={"m-auto text-white hidden xl:flex"}>{sedeNombre}</p> : null}
                </div>
              </div>
              :
              <>
              <div className={"flex m-auto lg:flex-row flex-col xl:justify-center elementFadeIn"}>
                {[{"IdSede": "59","Nombre": "Virtual a distancia"}].map(element => (
                  <>
                    <div className="flex flex-row">
                      <div
                        className={state.context.sede === element['IdSede'] ?
                        "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 bg-azulBrillanteMira hover:shadow-md hover:shadow-white" :
                        "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 hover:bg-azulBrillanteMira hover:shadow-md hover:shadow-white"}
                        onClick={() => handleSede(element['IdSede'], element.Nombre)}
                        onMouseEnter={() => setSedeNombre(element.Nombre)}
                      >
                        <p className="m-auto text-white text-2xl font-bold">{sedesIds(element['IdSede'])}</p>
                      </div>
                      <p className="block lg:hidden m-auto text-white">{element.Nombre}</p>
                    </div>
                  </>
                ))}

                <div className={"flex lg:w-1/2 w-full flex-col"}>
                  {/* <p className="text-secundario m-auto hidden xl:inline p-2">Virtual a distancia</p> */}
                  {nombreVisible ? <p className={"m-auto text-white hidden xl:flex"}>{sedeNombre}</p> : null}
                </div>
              </div>
              </>
              }
            </>
          }
          <ResumenAlumno
            urlCursos={urlCursos}
            datosInscripcion={state.context.datosUsuario}
            carnet={state.context.carnet}
          />
          {state.context.opcion > 0 && (
            <div className="flex bg-primarioMira justify-center content-center rounded-md p-2 m-1 /text-center">
              <div className="flex flex-col w-full xl:w-full p-1 m-1">
                <label
                  className='text-white'
                  htmlFor='Nombre1'>
                  {state.context.opcion === 1
                    ? 'Ingresa el motivo del cambio de horario'
                    : state.context.opcion === 2
                      ? 'Ingresa el motivo del traslado de fondos'
                      : 'Ingresa el motivo de la devolución'
                  }
                </label>
                <input
                  type="text"
                  name={'Nombre1'}
                  // onChange={(e) => handleChange(e)}
                  value=""
                  className='inline p-2 rounded-md' />
              </div>
            </div>
          )}
          <div className="text-center p-2 xl:hidden">
            <p className=" text-secundario m-auto inline">Debe seleccionar una sede para acceder a los catálogos de cursos que posee la misma</p>
          </div>
          
            {(sede && verCursos) && state.context.opcion !== 3
              ? <Cursos urlCursos={urlCursos} contador={contador} setContador={setContador} sede={sede} state={state} headers={headers} idCurso={idCurso} idSede={sede} send={send} cursos={cursos} setCursos={setCursos}></Cursos>
              : (sede | state.context.sede !== "") && state.context.opcion !== 3
              ? <Card urlCursos={urlCursos} data={catalogos} handleClick={handleOpen} textoBoton={"Ver cursos disponibles"} id="IdCatalogo" value="Descripcion" />
              : null
            }
          
        </div>
        <div className={"flex xl:w-[30%] lg:w-2/4 sm:w-full flex-col /pr-4 mx-auto"}>
          {state.context.opcion > 0 && (
            <ResumenAsignados
              urlCursos={urlCursos}
              data={copySeleccionadosSource[0].Cargos}
              handleDelete={handleDelete}
              opcion={state.context.opcion}
            />
          )}
          {state.context.seleccionados?.length > 0 && (
            <Resumen
              urlCursos={urlCursos}
              data={state.context.seleccionados}
              handleAplicaCupon={handleAplicaCupon}
              handleDelete={handleDelete}
            />
          )}
          {state.context.opcion === 3 && (
            <div className="p-2">
              <Total urlCursos={urlCursos} send={send} data={copySeleccionadosSource[0].Cargos} guardarCursosSeleccionados={guardarCursosSeleccionados} opcion={state.context.opcion} />
            </div>)
          }
          {state.context.seleccionados.length > 0 && (
            <div className="p-2">
              <Total urlCursos={urlCursos} send={send} data={state.context.seleccionados} guardarCursosSeleccionados={guardarCursosSeleccionados} opcion={state.context.opcion} />
            </div>
          )}
        </div>
        <div>
        </div>
      </div>
      <div className="flex flex-row justify-between p-2">
        <button
          className={"p-2 text-white bg-azulBrillanteMira rounded-md"}
          onClick={() => verCursos ? setVerCursos(false) : showOptions()} // preguntar si se va para atras o no con un dialogo, advirtiendo que se perderan los cambios en los cursos seleccionados
        >
          Atrás
        </button>
      </div>
    </div>
  );
};

export default Admision;
